import { defer, EMPTY, Observable } from "rxjs"
import { Router } from "../../../server/router"
import type { EpicDependencies } from "../../rxjs/configureEpics"
import {
    PASSWORD_RESET_REQUEST_FAILURE,
    PASSWORD_RESET_REQUEST_FORM_SUBMITTED,
    PASSWORD_RESET_REQUEST_SUCCESS,
    passwordResetRequestFailure,
    passwordResetRequestSuccess,
} from "./actions"
import { createLoadingEnded, createLoadingStarted } from "../../filters/actions"
import { createEventRequest, requestEvent } from "../../../events/utils"
import { getHttpHeaders } from "../../auth/selectors"
import { EventType } from "../../../events/types"
import { EventDataResponse } from "../../../graphql/types"
import { NotificationType, openNotification } from "../../uiKit/Notification/Notification"
import { Action, StateObject } from "../../redux/types"
import { ofType, StateObservable } from "redux-observable"
import { catchError, switchMap } from "rxjs/operators"

export const passwordResetRequestSubmittedEpics = (
    actions$: Observable<Action>,
    _state$: StateObservable<StateObject>,
    _deps: EpicDependencies
) =>
    actions$.pipe(
        ofType(PASSWORD_RESET_REQUEST_FORM_SUBMITTED),
        switchMap(() => [createLoadingStarted("password-reset-request")])
    )

export const passwordResetRequestRequestedEpics = (
    actions$: Observable<Action>,
    _state$: StateObservable<StateObject>,
    deps: EpicDependencies
) =>
    actions$.pipe(
        ofType(PASSWORD_RESET_REQUEST_FORM_SUBMITTED),
        switchMap((action: Action) => {
            return defer(() =>
                requestEvent(
                    getHttpHeaders(deps.getState()),
                    createEventRequest(
                        EventType.PasswordResetRequested,
                        {
                            correlationId: deps.idgen.next(),
                        },
                        {
                            email: action.payload.email,
                            callbackUrl: location.origin + "/reset-password",
                        },
                        0
                    )
                )
            ).pipe(
                switchMap((res: EventDataResponse) => {
                    const id = res?.id
                    if (!id) {
                        throw new Error("passwordResetRequestRequestedEpics - Id is missing")
                    }

                    return [createLoadingEnded("password-reset-request"), passwordResetRequestSuccess()]
                }),
                catchError(error => {
                    openNotification(NotificationType.Error, "Password reset request not successful", `${error}`)
                    return [createLoadingEnded("password-reset-request"), passwordResetRequestFailure(error)]
                })
            )
        })
    )

export const passwordResetRequestSuccessEpics = (
    actions$: Observable<Action>,
    _state$: StateObservable<StateObject>,
    _deps: EpicDependencies
) =>
    actions$.pipe(
        ofType(PASSWORD_RESET_REQUEST_SUCCESS),
        switchMap(() => {
            Router.push("/reset-password-request?success=true")
            return EMPTY
        })
    )

export const passwordResetRequestFailureEpics = (
    actions$: Observable<Action>,
    _state$: StateObservable<StateObject>,
    _deps: EpicDependencies
) =>
    actions$.pipe(
        ofType(PASSWORD_RESET_REQUEST_FAILURE),
        switchMap(() => {
            Router.push("/reset-password-request?error=true")
            return EMPTY
        })
    )
export default [
    passwordResetRequestSubmittedEpics,
    passwordResetRequestRequestedEpics,
    passwordResetRequestSuccessEpics,
]
